module.exports = __webpack_public_path__ + "img/check_2.67ede4d7.svg";